import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c62e676"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "transaction-info"
}
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "table-label" }
const _hoisted_5 = {
  class: "has-text-right status info",
  "data-testid": "status"
}
const _hoisted_6 = { class: "table-label" }
const _hoisted_7 = {
  class: "has-text-right",
  "data-testid": "network"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "table-label" }
const _hoisted_10 = { class: "has-text-right" }
const _hoisted_11 = { class: "table" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "table-label" }
const _hoisted_14 = { class: "has-text-right" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "executed-through-title" }
const _hoisted_18 = { class: "is-family-monospace" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "table-label" }
const _hoisted_21 = { class: "has-text-right" }
const _hoisted_22 = { class: "is-family-monospace" }
const _hoisted_23 = { class: "table-label" }
const _hoisted_24 = { class: "has-text-right" }
const _hoisted_25 = { "data-testid": "transaction-value" }
const _hoisted_26 = { class: "sub-text" }
const _hoisted_27 = { "data-testid": "transaction-value-in-fiat" }
const _hoisted_28 = { class: "table" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "table-label" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "has-text-right" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "table-label" }
const _hoisted_36 = {
  class: "has-text-right",
  "data-testid": "gasUsed"
}
const _hoisted_37 = {
  key: 0,
  class: "sub-text"
}
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { class: "table-label" }
const _hoisted_40 = { class: "has-text-right" }
const _hoisted_41 = { key: 3 }
const _hoisted_42 = { class: "table-label" }
const _hoisted_43 = {
  class: "has-text-right",
  "data-testid": "base-fee"
}
const _hoisted_44 = { key: 4 }
const _hoisted_45 = { class: "table-label" }
const _hoisted_46 = {
  class: "has-text-right",
  "data-testid": "max-fee-per-gas"
}
const _hoisted_47 = { key: 5 }
const _hoisted_48 = { class: "table-label" }
const _hoisted_49 = {
  class: "has-text-right",
  "data-testid": "max-priority-fee-per-gas"
}
const _hoisted_50 = { key: 6 }
const _hoisted_51 = { class: "table-label" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "has-text-right" }
const _hoisted_55 = { "data-testid": "transaction-fee" }
const _hoisted_56 = { class: "sub-text" }
const _hoisted_57 = { "data-testid": "transaction-fee-in-fiat" }
const _hoisted_58 = { class: "table" }
const _hoisted_59 = { class: "table-label" }
const _hoisted_60 = { class: "has-text-right is-family-monospace" }
const _hoisted_61 = ["href"]
const _hoisted_62 = { key: 2 }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "table-label" }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = {
  class: "has-text-right",
  "data-testid": "nonce"
}
const _hoisted_67 = { key: 0 }

import { computed, onMounted, ref, watchEffect } from 'vue'
import { fromWei } from 'web3-utils'

import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import Tooltip from '@/popup/components/shared/Tooltip/Tooltip.vue'
import useNumbers from '@/popup/compositions/useNumbers'
import { useAppStore } from '@/popup/store/AppStore'
import { isRelayerTransaction } from '@/shared/isTransactionMethods'
import { GlobalDatabase, PopupDatabase } from '@/popup/storage/Database'
import { truncateMiddle, urlReplace } from '@/shared/utils'
import { Transaction } from '@/shared/models/Transaction'
import { PreferencesState } from '@/popup/store/PreferencesStore'
import Spinner from '@/popup/components/shared/Spinner.vue'
import FormattedTokenAmount from '@/popup/components/shared/FormattedTokenAmount.vue'
import ClipboardCopy from '@/popup/components/shared/ClipboardCopy/ClipboardCopy.vue'
import { useProfileStore } from '@/popup/store/ProfileStore'

type Props = {
  transaction: Transaction
  isEstimate?: boolean
  preferences?: PreferencesState
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionInfo',
  props: {
    transaction: {},
    isEstimate: { type: Boolean },
    preferences: {}
  },
  setup(__props: any) {

const props = __props
const { formatCurrency, formatNumber } = useNumbers()
const appStore = useAppStore()
const explorerUrl = appStore.network.explorer?.url
const networkName = ref<string>()
const controllerKey = ref<string>()
const relayerName = ref<string | undefined>()

const eip1559Fees = computed(() => {
  const { baseFee, maxFeePerGas, maxPriorityFeePerGas } = props.transaction
  return {
    baseFee: baseFee ? fromWei(`${baseFee}`, 'Gwei') : undefined,
    maxFeePerGas: maxFeePerGas ? fromWei(maxFeePerGas, 'Gwei') : undefined,
    maxPriorityFeePerGas: maxPriorityFeePerGas
      ? fromWei(maxPriorityFeePerGas, 'Gwei')
      : undefined,
  }
})

const profileStore = useProfileStore()
const deviceController = computed(() => {
  if (!controllerKey.value) {
    return
  }
  return profileStore.getControllerByAddress(controllerKey.value)
})

onMounted(async () => {
  networkName.value = appStore.network.name
  const { controllerAddress } =
    (await PopupDatabase.getProfile(props.transaction.from)) || {}
  controllerKey.value = controllerAddress
})

watchEffect(async () => {
  if (props.transaction.gasProvider?.type === 'relayer') {
    const { transaction: { gasProvider: { id = '' } = {} } = {} } = props
    const { name } = (await GlobalDatabase.getRelayerById(id)) || {}
    relayerName.value = name
  }
})

return (_ctx: any,_cache: any) => {
  return (_ctx.transaction)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("tbody", null, [
            (_ctx.transaction.status === 'INITIALIZED')
              ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(Tooltip, {
                        value: _ctx.$t('transaction.details.status_tooltip'),
                        "offset-distance": "0",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            name: "info-circle",
                            class: "is-flex",
                            fill: "--neutral-60"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.details.status')), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.$t('activity.status.draft')), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(Tooltip, {
                    value: _ctx.$t('transaction.details.network_tooltip'),
                    "offset-distance": "0",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SvgIcon, {
                        name: "info-circle",
                        class: "is-flex",
                        fill: "--neutral-60"
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["value"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.details.network')), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("td", _hoisted_7, _toDisplayString(networkName.value), 1 /* TEXT */)
            ]),
            (_ctx.transaction.blockNumber)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(Tooltip, {
                        value: _ctx.$t('transaction.details.block_number_tooltip'),
                        "offset-distance": "0",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            name: "info-circle",
                            class: "is-flex",
                            fill: "--neutral-60"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.details.block_number')), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(formatNumber)(_ctx.transaction.blockNumber)), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createElementVNode("table", _hoisted_11, [
          _createElementVNode("tbody", null, [
            (_ctx.transaction.gasProvider)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(Tooltip, {
                        value: _ctx.$t('transaction.details.execute_method_tooltip'),
                        "offset-distance": "0",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            name: "info-circle",
                            class: "is-flex",
                            fill: "--neutral-60"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.details.executeMethod')), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_14, [
                    (_unref(isRelayerTransaction)(_ctx.transaction))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("span", null, _toDisplayString(relayerName.value), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(deviceController.value?.name ||
                  _ctx.$t(`transaction.details.execute_direct`)), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(ClipboardCopy, {
                              value: controllerKey.value,
                              "has-hover-text": false,
                              "offset-distance": "5"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(truncateMiddle)(controllerKey.value)), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["value"])
                          ])
                        ]))
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.transaction.to)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(Tooltip, {
                        value: _ctx.$t('transaction.details.to_tooltip'),
                        "offset-distance": "0",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            name: "info-circle",
                            class: "is-flex",
                            fill: "--neutral-60"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.details.to')), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(ClipboardCopy, {
                        value: _ctx.transaction.to,
                        "has-hover-text": false,
                        "offset-distance": "5"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(truncateMiddle)(_ctx.transaction.to)), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"])
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(Tooltip, {
                    value: _ctx.$t('transaction.details.value_tooltip'),
                    "offset-distance": "0",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SvgIcon, {
                        name: "info-circle",
                        class: "is-flex",
                        fill: "--neutral-60"
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["value"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.details.value')), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("td", _hoisted_24, [
                _createElementVNode("div", null, [
                  _createVNode(FormattedTokenAmount, {
                    class: "icon-button",
                    decimals: 18,
                    "tooltip-offset-distance": _ctx.transaction.value ? '5' : '0',
                    amount: _ctx.transaction.value,
                    symbol: props.preferences?.token.symbol
                  }, {
                    default: _withCtx(({ amount, symbol }) => [
                      _createElementVNode("span", _hoisted_25, _toDisplayString(`${amount} ${symbol}`), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["tooltip-offset-distance", "amount", "symbol"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(Tooltip, {
                    class: "icon-button",
                    value: 
                  _unref(formatCurrency)(
                    _ctx.transaction.value || '0',
                    _ctx.preferences?.currentCurrency,
                    _ctx.preferences?.currencies,
                    false
                  )
                ,
                    "offset-distance": _ctx.transaction.value ? '5' : '0'
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(`(${_unref(formatCurrency)(
                      props.transaction.value || '0',
                      props.preferences?.currentCurrency,
                      props.preferences?.currencies
                    )})`), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["value", "offset-distance"])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("table", _hoisted_28, [
          _createElementVNode("tbody", null, [
            (_ctx.transaction.gasLimit)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(Tooltip, {
                        value: _ctx.$t('transaction.details.gas_limit_tooltip'),
                        "offset-distance": "0",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            name: "info-circle",
                            class: "is-flex",
                            fill: "--neutral-60"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"]),
                      (_ctx.isEstimate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t('transaction.details.gas_limit')) + _toDisplayString(_ctx.$t('transaction.details.estimated')), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t('transaction.details.gas_limit')), 1 /* TEXT */))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_33, _toDisplayString(_unref(formatNumber)(_ctx.transaction.gasLimit)), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.transaction.gasUsed)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(Tooltip, {
                        value: _ctx.$t('transaction.details.gas_used_tooltip'),
                        "offset-distance": "0",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            name: "info-circle",
                            class: "is-flex",
                            fill: "--neutral-60"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.details.gas_used')), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_36, [
                    _createTextVNode(_toDisplayString(_unref(formatNumber)(_ctx.transaction.gasUsed)) + " ", 1 /* TEXT */),
                    (_ctx.transaction.gasUsedPercent)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_unref(formatNumber)(_ctx.transaction.gasUsedPercent)) + "% ", 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (
            _ctx.transaction.gasPrice &&
            !eip1559Fees.value.maxFeePerGas &&
            !eip1559Fees.value.maxPriorityFeePerGas
          )
              ? (_openBlock(), _createElementBlock("tr", _hoisted_38, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(Tooltip, {
                        value: _ctx.$t('transaction.details.gas_price_tooltip'),
                        "offset-distance": "0",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            name: "info-circle",
                            class: "is-flex",
                            fill: "--neutral-60"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.details.gas_price')), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_40, _toDisplayString(_unref(formatNumber)(
                _unref(fromWei)(_ctx.transaction.gasPrice || '0', 'Gwei'),
                'short'
              )) + " Gwei ", 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            (eip1559Fees.value.baseFee)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_41, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(Tooltip, {
                        value: _ctx.$t('transaction.details.baseFee_tooltip'),
                        "offset-distance": "0",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            name: "info-circle",
                            class: "is-flex",
                            fill: "--neutral-60"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.details.base_fee')), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_43, _toDisplayString(eip1559Fees.value.baseFee) + " Gwei ", 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            (eip1559Fees.value.maxFeePerGas)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_44, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(Tooltip, {
                        value: _ctx.$t('transaction.details.maxFee_tooltip'),
                        "offset-distance": "0",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            name: "info-circle",
                            class: "is-flex",
                            fill: "--neutral-60"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.details.max_fee_per_gas')), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_46, _toDisplayString(eip1559Fees.value.maxFeePerGas) + " Gwei ", 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            (eip1559Fees.value.maxPriorityFeePerGas)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_47, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(Tooltip, {
                        value: _ctx.$t('transaction.details.maxPriorityFee_tooltip'),
                        "offset-distance": "0",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            name: "info-circle",
                            class: "is-flex",
                            fill: "--neutral-60"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.details.maxPriorityFee')), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_49, _toDisplayString(eip1559Fees.value.maxPriorityFeePerGas) + " Gwei ", 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.transaction.transactionFee)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_50, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(Tooltip, {
                        value: _ctx.$t('transaction.details.transaction_fee_tooltip'),
                        "offset-distance": "0",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            name: "info-circle",
                            class: "is-flex",
                            fill: "--neutral-60"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"]),
                      (_ctx.isEstimate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.$t('transaction.details.transaction_fee')) + _toDisplayString(_ctx.$t('transaction.details.estimated')), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.$t('transaction.details.transaction_fee')), 1 /* TEXT */))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_54, [
                    _createElementVNode("div", null, [
                      _createVNode(FormattedTokenAmount, {
                        class: "icon-button",
                        decimals: 18,
                        amount: _ctx.transaction.transactionFee,
                        symbol: _ctx.preferences?.token.symbol
                      }, {
                        default: _withCtx(({ amount, symbol }) => [
                          _createElementVNode("span", _hoisted_55, _toDisplayString(`${amount} ${symbol}`), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["amount", "symbol"])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createVNode(Tooltip, {
                        value: 
                  _unref(formatCurrency)(
                    _ctx.transaction.transactionFee,
                    _ctx.preferences?.currentCurrency,
                    _ctx.preferences?.currencies,
                    false
                  )
                
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_57, _toDisplayString(`(${_unref(formatCurrency)(
                      _ctx.transaction.transactionFee,
                      _ctx.preferences?.currentCurrency,
                      _ctx.preferences?.currencies
                    )})`), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"])
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createElementVNode("table", _hoisted_58, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_59, [
                  _createVNode(Tooltip, {
                    value: _ctx.$t('transaction.details.hash_tooltip'),
                    "offset-distance": "0",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SvgIcon, {
                        name: "info-circle",
                        class: "is-flex",
                        fill: "--neutral-60"
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["value"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.details.hash')), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("td", _hoisted_60, [
                (!_ctx.transaction.transactionHash)
                  ? (_openBlock(), _createBlock(Spinner, {
                      key: 0,
                      class: "activity-spinner ml-1",
                      "data-testid": "spinner"
                    }))
                  : (_ctx.transaction.transactionHash && _unref(explorerUrl))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: 
                _unref(urlReplace)(
                  _unref(explorerUrl),
                  'transactionId',
                  _ctx.transaction?.transactionHash
                )
              ,
                        rel: "nofollow, noopener",
                        target: "_blank"
                      }, _toDisplayString(_unref(truncateMiddle)(_ctx.transaction.transactionHash)), 9 /* TEXT, PROPS */, _hoisted_61))
                    : (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_unref(truncateMiddle)(_ctx.transaction.transactionHash)), 1 /* TEXT */))
              ])
            ]),
            (_ctx.transaction.nonce && !_unref(isRelayerTransaction)(_ctx.transaction))
              ? (_openBlock(), _createElementBlock("tr", _hoisted_63, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(Tooltip, {
                        value: _ctx.$t('transaction.details.nonce_tooltip'),
                        "offset-distance": "0",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            name: "info-circle",
                            class: "is-flex",
                            fill: "--neutral-60"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"]),
                      _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('transaction.details.nonce')) + " ", 1 /* TEXT */),
                        (_ctx.transaction.transactionIndex)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_65, "| " + _toDisplayString(_ctx.$t('transaction.details.transactionIndex')), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_66, [
                    _createTextVNode(_toDisplayString(_unref(formatNumber)(_ctx.transaction.nonce)) + " ", 1 /* TEXT */),
                    (_ctx.transaction.transactionIndex)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_67, "| " + _toDisplayString(_unref(formatNumber)(_ctx.transaction.transactionIndex)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})